// extracted by mini-css-extract-plugin
export default {"cls1":"FocusedNav-cls1_m__","cls2":"FocusedNav-cls2_xxv FocusedNav-cls1_m__","isMobileNav":"FocusedNav-isMobileNav__45"};